// S2-FE2: StatusDot
import './StatusDot.css';

export interface StatusDotProps {
  status: 'ready' | 'not-ready' | 'conditional' | 'evaluating';
  label?: string;
}

export function StatusDot({ status, label }: StatusDotProps) {
  return (
    <span className={`airgent-status airgent-status-${status}`}>
      <span className={`airgent-status-dot airgent-status-dot-${status}`} />
      {label && (
        <span className={`airgent-status-label airgent-status-label-${status}`}>
          {label}
        </span>
      )}
    </span>
  );
}
